import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'checkout-funding-infos-phone-line',
    templateUrl: './funding-infos-phone-line.component.html',
    styleUrl: 'funding-infos-phone-line.component.scss',
    standalone: true,
    imports: [NgClass],
})
export class FundingInfosPhoneLineComponent {
    @Input() lineTitle: string;
    @Input() value: string;
    @Input() isBold = false;
}
